import './Input.scss';
import { Icons } from '../Icons/Icons';
import { useState, useCallback } from 'react';
import { formatPhoneNumber } from '../../utils/phoneMask';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  touched?: boolean;
  mask?: 'phone';
}

export const Input = ({ label, error, touched, type, mask, onChange, ...props }: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (mask === 'phone') {
        const rawValue = e.target.value;
        const formattedValue = formatPhoneNumber(rawValue);
        e.target.value = formattedValue;
      }

      if (onChange) {
        onChange(e);
      }
    },
    [mask, onChange]
  );

  return (
    <div className="form-group">
      <label htmlFor={props.id}>{label}</label>
      <div className="input-wrapper">
        <input
          {...props}
          className={touched && error ? 'error' : ''}
          type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
          onChange={handleChange}
        />
        {type === 'password' && (
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? Icons.HiddenPassword : Icons.ShownPassword}
          </button>
        )}
      </div>
      {touched && error && <div className="error">{error}</div>}
    </div>
  );
};
